export const SESSION_HINT_COOKIE = "repackify-signed-in";

export function hasSessionHintCookie(): boolean {
  return document.cookie
    .split(";")
    .some((part) => part.trim() === `${SESSION_HINT_COOKIE}=1`);
}
